export const paymentReqForTransfer = `<p>A Request for Transfer (MT101) is a method to make payments from Multibank accounts you hold with other institutions.</p>
<p>You'll need the beneficiary's full account details, including the IBAN if applicable.</p>
<p><strong>Navigation</strong>: Payments / Create Payments / Request for Transfer</p>
<p><strong>Step 1</strong></p>
<p>Select the Multibank debit account you wish to create a payment from, using the Advanced Search or dropdown list of accounts you are entitled to. Access to the required Multibank (Shadow) accounts is enabled with the account usage flag of ‘Payments’ or ‘Reporting and Payments’ when you create the Multibank account.</p>
<p>This will then populate debit account details and allow you to input additional payment information.&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/11/1.png' /></p>
<li><strong>Beneficiary Details</strong></li>
<p>Enter the beneficiary details in the boxes provided. This can be done as free text if the User has the entitlement set for ‘Freeform request for transfer beneficiary’ set against their Role Profile (Refer to Section <a href='javascript:void(0)' data-link='setupActivityRoleProfileUser'>'Set-up activity for role profiles and users'</a> for Role Profile information)&nbsp;</p>
<p>Alternatively, the user can search for saved beneficiaries by using the search button on the right hand side. <em>(To create a new Beneficiary refer to section <a href='javascript:void(0)' data-link='manageBeneficiaries'>'Manage Beneficiaries'</a>).</em> Search can be done on Sort Code, Account Number, Beneficiary Name, Preferred name or Bank ID.</p>
<p>Note that "<span style='color:red'>*</span>" denotes fields which are mandatory.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/11/5.png' /></p>
<p>The table shows you the field lengths and permitted character set for the beneficiary name and address fields.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/11/6.png' /></p>
<li><strong>Beneficiary account type = IBAN</strong></li>
<p>Where an <strong>IBAN</strong> is available to support the payment this should be used by selecting IBAN from the Beneficiary account type drop down. The following fields must be populated to support the successful processing of the payment.&nbsp;</p>
<ul>
<li>
Beneficiary Details
<ul class='list-style-circle'>
  <li>Beneficiary Name</li>
  <li>Beneficiary Account Type – Select IBAN</li>
  <li>Beneficiary Account Number – Add IBAN</li>
  <li>Town/City – Input the town or city of the beneficiary</li>
  <li>Country – Select the country of beneficiary</li>
</ul>
</li>
<li>
Beneficiary Bank Details
<ul class='list-style-circle'>
  <li>Beneficiary Bank SWIFT BIC - 11 character Branch BIC is preferable if known, if not use 8 character Head Office BIC</li>
</ul>
</li>
</ul>
<li><strong>Beneficiary account type = BBAN</strong></li>
<p>If you have selected <strong>BBAN</strong> from the Beneficiary account type drop down, the following fields must be populated to support the successful processing of the payment.&nbsp;</p>
<ul>
<li>
Beneficiary Details
<ul class='list-style-circle'>
<li>Beneficiary Name</li>
<li>Beneficiary Account Type – Select BBAN</li>
<li>Beneficiary Account Number – Provide the account number in the format required by the chosen Beneficiary Bank Code Type.</li>
<li>Town/City – Input the town or city of the beneficiary</li>
<li>Country – Select the country of beneficiary</li>
</ul>
</li>
<li>
Beneficiary Bank Details - <strong>For a UK Beneficiary</strong>
<ul class='list-style-circle'>
<li>Beneficiary Bank Code Type - Select GBDSC</li>
<li>Beneficiary Bank Code - Enter the UK Sort Code (ONLY)</li>
</ul>
</li>
<li>
Beneficiary Bank Details - <strong>For a Non-UK Beneficiary</strong>
<ul class='list-style-circle'>
<li>Beneficiary Bank Code Type - Select relevant option for Country (e.g.USABA)</li>
<li>Beneficiary Bank Code – Enter relevant NCC for Country</li>
</ul>
</li>
</ul>
<li><strong>Beneficiary account type = OTHER</strong></li>
<p>If you have selected <strong>OTHER</strong> from the Beneficiary account type drop down, the following fields must be populated to support the successful processing of the payment.</p>
<ul>
<li>
Beneficiary Details
<ul class='list-style-circle'>
  <li>Beneficiary Name</li>
  <li>Beneficiary Account Type – Select OTHER</li>
  <li>Beneficiary Account Number – Enter Account Number in the format defined by the Beneficiary Bank</li>
  <li>Town/City – Input the town or city of the beneficiary</li>
  <li>Country – Select the country of beneficiary</li>
</ul>
</li>
<li>
Beneficiary Bank Details
<ul class='list-style-circle'>
  <li>SWIFT BIC - 11 character Branch BIC is preferable if known, if not use 8 character Head Office BIC</li>
  <li>Beneficiary Bank Name</li>
</ul>
</li>
</ul>
<li><strong>Beneficiary reference</strong></li>
<ul>
<li>Beneficiary reference section is optional.</li>
<li>If beneficiary reference details are populated then a maximum of 105 characters can be added within 3 of the fields. Any information provided in excess of 105 characters will be excluded from the outgoing payment message</li>
</ul>
<li><strong>Special Instructions</strong></li>
<ul>
<li>When creating a Request for Transfer you can optionally provide the account holding bank with Special instructions around how to process the resultant payment.</li>
<li>You can select either “URGP” (urgent payment) or “RTGS” (RTGS payment) from the drop down.</li>
<li>URGP requests the account holding bank to process the payment urgently.</li>
<li>RTGS requests that the payment is settled by a same day payment system.</li>
<li>If the account holding bank acts on the special instructions, additional costs may be incurred.</li>
<li>Note: when the request is to a Lloyds non-GEM currency account, use RTGS. Prior agreement is required to ensure that this is set up on the non-GEM currency account.</li>
<li>The selection will be sent in field 23E on the MT101.</li>
</ul>
<li><strong>Payment Details</strong></li>
<ul>
  <li>Execution date is pre-populated but can be changed for a future value dated payment.</li>
  <li>Credit <strong>or</strong> Debit amount must be populated. (Debit currency will default to currency of debit account selected). Where a currency conversion is selected then an Indicative rate will be displayed for information only. The Account holding bank (AHB) will establish the actual FX rate</li>
  <li>Charges will default to Shared but can be amended to Ours or Beneficiary.</li>
  <li>You may have a pre-booked FX rate and enter the contract ID and FX rate in the initiation screen, which will not be validated by LLOYDS BANK as this is with the account holding bank.&nbsp;</li>
</ul>
<p>Once you have completed the relevant sections above the payment request can be completed by clicking on submit and then done.</p>
<p><strong>Step 2&nbsp;</strong></p>
<p>This is a display of all the payment information entered and the user has an option to edit data before clicking on submit to proceed to approval.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/11/2.png' /></p>
<p><strong>Step 3</strong></p>
<p>This shows the user the payment that has been submitted to approval.&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/11/3.png' /></p>
<p>If the user wants to edit or delete now, they have to find the payment in payment summary.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/11/4.png' /></p>`;


// WEBPACK FOOTER //
// ./src/components/content/payments/13-requestForTransfer.ts